<template>
    <defaultSec :title="'< 返回'" :returnState="true">
        <div>
            <el-form v-model="form" label-width="120px">
                <el-form-item label="案例名称" prop="experienceName" :required="true">
                    <el-input v-model="form.experienceName" placeholder="请输入案例名称"></el-input>
                </el-form-item>
                <el-form-item label="描述" prop="experienceDesc">
                    <el-input v-model="form.experienceDesc" placeholder="请输入描述"></el-input>
                </el-form-item>
                <el-form-item label="案例类型" prop="type" :required="true">
                    <el-select v-model="form.type" :disabled="form.experienceId>0" @change="caseTypeChange" filterable
                               clearable
                               placeholder="请选择案例类型">
                        <el-option v-for="item in experienceTypeList"
                                   :key="item.value"
                                   :label="item.name"
                                   :value="item.value"
                                   :disabled="item.unUse"
                        ></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="素材" prop="materailId" v-show="form.type==3" :required="true">
                    <el-select v-model="form.materailId" filterable clearable
                               placeholder="素材">
                        <el-option v-for="item in materialList"
                                   :key="item.value"
                                   :label="item.label"
                                   :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="案例" :required="true">
                    <!-- 图片上传组件辅助，组件内添加v-show=“false”属性，把该组件隐藏起来。-->
                    <el-upload class="avatar-uploader"
                               :action="uploadUrl"
                               :show-file-list="false"
                               :on-success="uploadSuccess"
                               :before-upload="beforeAvatarUpload">
                    </el-upload>
                    <quill-editor
                            v-model="form.experienceContent"
                            ref="myQuillEditor"
                            :options="editorOption"
                            @blur="onEditorBlur($event)" @focus="onEditorFocus($event)"
                            @change="onEditorChange($event)">
                    </quill-editor>
                </el-form-item>
                <el-form-item label="填写状态" prop="status" v-show="form.experienceId>0">
                    <el-select v-model="form.status" :disabled="true" filterable clearable
                               placeholder="填写状态">
                        <el-option v-for="item in statusList"
                                   :key="item.value"
                                   :label="item.name"
                                   :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button-group>
                        <el-button type="primary" @click="save()" :disabled="form.canEdit!=1" size="mini"
                                   class="header-btn">
                            保存
                        </el-button>
                        <el-button type="warning" v-show="form.canAuditing==1" size="mini"
                                   @click="auditingCase()">审核
                        </el-button>
                        <el-button type="danger" v-show="operateType==1" size="mini"
                                   @click="cancelCase()">作废
                        </el-button>
                        <el-button type="warning" v-show="form.canVote==1" size="mini"
                                   @click="vote()">有用
                        </el-button>
                    </el-button-group>
                </el-form-item>
            </el-form>
        </div>
    </defaultSec>
</template>

<script>
    import defaultSec from '@c/defaultSection'
    import tablePagination from '@c/tablePagination'
    import {baseUrl} from '@/api/http'
    import {quillEditor} from "vue-quill-editor"; //调用编辑器
    import * as Quill from 'quill'
    import 'quill/dist/quill.core.css';
    import 'quill/dist/quill.snow.css';
    import 'quill/dist/quill.bubble.css';

    const toolbarOptions = [
        ['bold', 'italic', 'underline', 'strike'],        // 加粗，斜体，下划线，删除线
        ['blockquote', 'code-block'],                      //引用，代码块
        [{'header': 1}, {'header': 2}],               // 几级标题
        [{'list': 'ordered'}, {'list': 'bullet'}],     // 有序列表，无序列表
        [{'script': 'sub'}, {'script': 'super'}],      // 下角标，上角标
        [{'indent': '-1'}, {'indent': '+1'}],          // 缩进
        [{'direction': 'rtl'}],                         // 文字输入方向
        [{'size': ['small', false, 'large', 'huge']}],  // 字体大小
        [{'header': [1, 2, 3, 4, 5, 6, false]}],// 标题
        [{'color': []}, {'background': []}],          // 颜色选择
        [{'font': ['SimSun', 'SimHei', 'Microsoft-YaHei', 'KaiTi', 'FangSong', 'Arial']}],// 字体
        [{'align': []}], // 居中
        ['clean'],                                       // 清除样式,
        ['link', 'image'],  // 上传图片、上传视频
    ]
    export default {
        data() {
            return {
                experienceTypeList: [],
                showDialog: false,
                statusList: [],
                materialList: [],
                showDialog: false,
                operateType: this.$route.params.operateType || 2,
                voteForm: {
                    voteId: '',
                    voteTargetType: 1,
                    voteTargetId: this.$route.params.experienceId || 0,
                    voteType: 1,
                    comment: ''
                },
                form: {
                    experienceId: this.$route.params.experienceId || 0,
                    qwUserid: '',
                    qyWeixinUserid: '',
                    qwNickname: '',
                    experienceName: '',
                    experienceDesc: '',
                    type: 2,
                    status: 0,
                    experienceContent: '',
                    createTime: '',
                    createDate: '',
                    endTime: '',
                    materailId: '',
                    auditing: '',
                    auditingTime: '',
                    auditingUserid: '',
                    auditingAdvice: '',
                    canEdit: 1,
                    voteTotal: ''
                },
                editorOption: {
                    modules: {
                        toolbar: {
                            container: toolbarOptions,
                            handlers: {
                                'image': function (value) {
                                    if (value) { // value === true
                                        document.querySelector('.avatar-uploader input').click()
                                    } else {
                                        this.quill.format('image', false)
                                    }
                                }
                            }
                        },
//                        imageResize: {
//                            displayStyles: {
//                                backgroundColor: 'black',
//                                border: 'none',
//                                color: 'white'
//                            },
//                            modules: ['Resize', 'DisplaySize', 'Toolbar']
//                        }
                    },
                    placeholder: '请输入正文',
                    theme: "snow",
                },
                uploadUrl: `${baseUrl}/lechun-cms/collageManage/uploadCollageConfigBanner`
            }
        },
        components: {
            defaultSec, tablePagination, quillEditor
        },
        computed: {
            editor() {
                return this.$refs.myQuillEditor.quill;
            },
        },
        mounted(){
            this.getCaseStatusList()
            this.getCaseTypeList()
            this.initMaterialOption()
            if (this.form.experienceId > 0) {
                this.getDetail()
            }
        },
        methods: {
            initMaterialOption(){
                this.$apiGet('lechun-cms/scrmMaterial/getOptionMaterialList', {'materialClass': 1}).then(res => {
                    this.materialList = res;
                })
            },
            getCaseStatusList(){
                this.$apiGet('lechun-cms/experience/getCaseStatusList', {}).then(res => {
                    console.log(res)
                    this.statusList = res
                })
            },
            getCaseTypeList(){
                this.$apiGet('lechun-cms/experience/getCaseTypeList', {}).then(res => {
                    console.log(res)
                    this.experienceTypeList = res
                })
            },
            onEditorReady(editor) { // 准备编辑器

            },
            onEditorBlur(){
            }, // 失去焦点事件
            onEditorFocus(){
            }, // 获得焦点事件
            onEditorChange(){
            }, // 内容改变事件
            //把实体格式字符串转义成HTML格式的字符串
            escapeStringHTML(str) {
                str = str.replace(/&lt;/g, '<');
                str = str.replace(/&gt;/g, '>');
                return str;
            },
            beforeAvatarUpload(file) {
                const isLt2M = file.size / 1024 / 1024 < 1;
                if (!isLt2M) {
                    this.$message.error('上传头像图片大小不能超过 1MB!');
                }
                return isLt2M;
            },
            uploadSuccess (res) {
                // 获取富文本组件实例
                let quill = this.$refs.myQuillEditor.quill
                if (res.success) {
                    // 获取光标所在位置
                    let length = quill.getSelection().index;
                    // 插入图片，res为服务器返回的图片链接地址
                    quill.insertEmbed(length, 'image', res.value)
                    // 调整光标到最后
                    quill.setSelection(length + 1)
                } else {
                    // 提示信息，需引入Message
                    this.$message.error('图片插入失败！')
                }
            },
            caseTypeChange(type){
                if (this.form.type == 1 || this.form.type == 2) {
                    this.form.materailId = ''
                }
            },
            getDetail() {
                this.$apiGet('lechun-cms/experience/getCase', {
                    experienceId: this.form.experienceId,
                    operateType: this.operateType
                }).then(res => {
                    this.form = res
                })
            },
            auditingCase() {
                this.$apiGet('lechun-cms/experience/auditingCase', {
                    experienceId: this.form.experienceId,
                    operateType: this.operateType
                }).then(res => {
                    this.$message({
                        message: '成功',
                        type: 'success'
                    });
                    this.getDetail()
                })
            },
            cancelCase() {
                this.$confirm('作废不可撤销,确定作废吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$apiGet('lechun-cms/experience/cancelCase', {
                        experienceId: this.form.experienceId,
                        operateType: this.operateType
                    }).then(res => {
                        this.$message({
                            message: '成功',
                            type: 'success'
                        });
                        this.getDetail()
                    })
                }).catch(() => {

                });
            },
            vote() {
//                this.$apiPost('lechun-cms/experience/saveVote', this.voteForm).then(res => {
                this.$apiGet('lechun-cms/experience/saveVote', {
                    voteTargetType: 1,
                    voteTargetId: this.form.experienceId,
                    voteType: 1,
                    comment: ''
                }).then(res => {
                    this.$message({
                        message: '成功',
                        type: 'success'
                    });
                    this.getDetail()
                })
            },
            save(){
                if (this.form.experienceName == '') {
                    this.$message({
                        showClose: true,
                        message: '案例名称必填',
                        type: 'error'
                    });
                    return;
                }
                if (this.form.experienceContent == '') {
                    this.$message({
                        showClose: true,
                        message: '案例内容必填',
                        type: 'error'
                    });
                    return;
                }
                if (this.form.type == 0) {
                    this.$message({
                        showClose: true,
                        message: '案例类型必选',
                        type: 'error'
                    });
                    return;
                }
                if (this.form.type == 3) {
                    if (this.form.materailId == '') {
                        this.$message({
                            showClose: true,
                            message: 'SOP案例素材必选',
                            type: 'error'
                        });
                        return;
                    }
                }
                this.$apiPost('lechun-cms/experience/saveCase', this.form).then(res => {
                    console.log(res)
                    this.$message({
                        message: '保存成功',
                        type: 'success'
                    });
                    this.$router.push({path: '/experience', name: 'experience'})
                })
            }
        }
    }
</script>

<style scoped>
    .expand-title {
        width: 70px;
        color: #444548;
        line-height: 30px;
        text-align: right;
        margin-right: 10px;
        font-weight: 600;
    }

    .expand-flex {
        justify-content: flex-start;
        align-items: center;
        align-content: center;
    }

    /*加上height和滚动属性就可以，滚动条样式是系统默认样式，可能不同*/
    .ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-options {
        border-color: #ccc;
        height: 125px;
        overflow: auto;
    }

    .ql-editor {
        height: 400px;
    }

    .editor {
        line-height: normal !important;
        height: 400px;
        margin-bottom: 50px;
    }

    .edit_container {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
        margin-top: 60px;
    }

    .ql-snow .ql-tooltip[data-mode="link"]::before {
        content: "请输入链接地址:";
    }

    .ql-snow .ql-tooltip.ql-editing a.ql-action::after {
        border-right: 0px;
        content: "保存";
        padding-right: 0px;
    }

    .ql-snow .ql-tooltip[data-mode="video"]::before {
        content: "请输入视频地址:";
    }

    .ql-snow .ql-picker.ql-size .ql-picker-label::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item::before {
        content: "14px";
    }

    .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="small"]::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="small"]::before {
        content: "10px";
    }

    .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="large"]::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="large"]::before {
        content: "18px";
    }

    .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="huge"]::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="huge"]::before {
        content: "32px";
    }

    .ql-snow .ql-picker.ql-header .ql-picker-label::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item::before {
        content: "文本";
    }

    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="1"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
        content: "标题1";
    }

    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="2"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
        content: "标题2";
    }

    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="3"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
        content: "标题3";
    }

    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="4"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
        content: "标题4";
    }

    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="5"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
        content: "标题5";
    }

    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="6"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
        content: "标题6";
    }

    .ql-snow .ql-picker.ql-font .ql-picker-label::before,
    .ql-snow .ql-picker.ql-font .ql-picker-item::before {
        content: "标准字体";
    }

    .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="serif"]::before,
    .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="serif"]::before {
        content: "衬线字体";
    }

    .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="monospace"]::before,
    .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="monospace"]::before {
        content: "等宽字体";
    }
</style>